<template>
  <div>
    <b-container class="my-5">
      <form @submit.prevent="addForm(form)">
        <div>
          <b-form-input
            v-model="form.name"
            placeholder="Nombre:"
            class="mb-2"
            :class="{ 'is-invalid': $v.form.name.$error }"
          ></b-form-input>
          <b-alert
            v-if="!$v.form.name.required"
            show
            fade
            dismissible
            variant="info"
            >Campo requerido</b-alert
          >
          <b-alert
            v-if="!$v.form.name.minLength"
            show
            fade
            dismissible
            variant="danger"
            >4 caracteres mínimo</b-alert
          >
          <b-alert
            v-if="!$v.form.name.maxLength"
            show
            fade
            dismissible
            variant="danger"
            >Maximo de caracteres permitidos</b-alert
          >
        </div>

        <div>
          <b-form-input
            v-model.lazy="form.email"
            placeholder="Correo:"
            class="mb-2"
            :class="{ 'is-invalid': $v.form.email.$error }"
          ></b-form-input>
          <b-alert
            v-if="!$v.form.email.required"
            show
            fade
            dismissible
            variant="info"
            >Campo requerido</b-alert
          >
          <b-alert
            v-if="!$v.form.email.email"
            show
            fade
            dismissible
            variant="danger"
            >Este email es incorrecto</b-alert
          >
        </div>

        <div>
          <b-form-textarea
            id="textfk"
            v-model.lazy="form.fk"
            placeholder="Mensaje:"
            rows="3"
            max-rows="6"
            class="mb-2"
            hidden
          ></b-form-textarea>
        </div>

        <div>
          <b-form-textarea
            id="textarea"
            v-model.lazy="form.text"
            placeholder="Mensaje:"
            rows="3"
            max-rows="6"
            class="mb-2"
            :class="{ 'is-invalid': $v.form.text.$error }"
          ></b-form-textarea>
          <b-alert
            v-if="!$v.form.text.required"
            show
            fade
            dismissible
            variant="info"
            >Campo requerido</b-alert
          >
          <b-alert
            v-if="!$v.form.text.minLength"
            show
            fade
            dismissible
            variant="danger"
            >5 caracteres mínimo</b-alert
          >
          <b-alert
            v-if="!$v.form.text.maxLength"
            show
            fade
            dismissible
            variant="danger"
            >Maximo de caracteres permitidos</b-alert
          >
        </div>

        <button type="submit" class="btn-blue bold" v-if="!$v.$invalid || carga">
          ENVIAR
        </button>
        <button type="reset" class="btn-blue bold">LIMPIAR</button>
      </form>


 <!-- {{form}} -->

    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  required,
  minLength,
  maxLength,
  email,
  helpers,
} from "vuelidate/lib/validators";
import moment from 'moment'
const textURL = helpers.regex(
  "textURL",
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
);

export default {
  name: "Form",
  data() {
    return {
      form: {
        name: "",
        email: "",
        text: "",
        fk: "",
        createdDate: moment().format('YYYY/MM/DD HH:mm')

      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(50),
      },
      email: {
        required,
        email,
      },
      text: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(150),
      },
      fk: {
        maxLength: maxLength(0),
        textURL,
      },
    },
  },


  methods: {
    ...mapActions(['addForm']),


  },
  computed: {
    ...mapState(['carga'])
  },
};
</script>

<style>
</style>